function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent, ref, computed } from "vue";
import FakeSelect from "@com/components/fake-select/index.vue";
import { ElSchemaFormItem } from "el-schema-form";
export default defineComponent({
    components: {
        FakeSelect: FakeSelect,
        ElSchemaFormItem: ElSchemaFormItem
    },
    props: {
        popoverConfig: Object,
        label: String,
        selectedValue: Array,
        model: Object,
        popoverSchema: Array
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var innerConfig = computed(function() {
            return _objectSpread({
                placement: "bottom-start",
                width: 200,
                trigger: "click",
                "popper-class": "el-picker-panel"
            }, props.popoverConfig);
        });
        var visible = ref(false);
        var handleChange = function(value) {
            emit("change", value);
        };
        var formConfig = {
            inline: true
        };
        var deleteTag = function(tag) {
            emit("remove-tag", tag);
        };
        var handleClearClick = function(event) {
            emit("clear");
        };
        return {
            visible: visible,
            innerConfig: innerConfig,
            formConfig: formConfig,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
